import { paths } from '../paths';
import { lazyLoadPage } from '../utils';

export const authRoutes = [
  {
    path: paths.SIGN_UP,
    element: lazyLoadPage('sign-up', { path: '(auth)/' }),
    state: {
      pageKey: 'auth',
      metadata: {
        title: 'Sign Up'
      }
    }
  },
  {
    path: paths.SIGN_IN,
    element: lazyLoadPage('sign-in', { path: '(auth)/' }),
    state: {
      pageKey: 'auth',
      metadata: {
        title: 'Sign In'
      }
    }
  },
  {
    path: paths.SIGN_OUT,
    element: lazyLoadPage('sign-out', { path: '(auth)/' }),
    state: {
      pageKey: 'logout',
      metadata: {
        title: 'Logout'
      }
    }
  },
  {
    path: paths.VALIDATE,
    element: lazyLoadPage('validate', { path: '(auth)/' }),
    state: {
      pageKey: 'auth',
      metadata: {
        title: 'Validation'
      }
    }
  },
  {
    path: paths.SELECT_ORGANIZATION,
    element: lazyLoadPage('select-organization', { path: '(auth)/' }),
    state: {
      pageKey: 'auth',
      metadata: {
        title: 'Select an organization'
      }
    }
  }
];
